export enum SessionStorageKeys {
  unlinkDate = "unlinkDate",
  linkDate = "linkDate",
}
